import React, { useState } from "react";
import * as Yup from "yup";
import CustomModalContainer from "../../../components/modals/CustomModalContainer";
import Button from "../../ui/Button";
import Dropdown from "../../ui/SelectDropdown";
import ConfirmRejectKycModal from "./ConfirmRejectKycModal";

interface RejectKycModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: any;
  onSave: () => void;
}

const validationSchema = Yup.object({
  kycStatus: Yup.string().required("KYC status is required"),
});

const kycStatusOptions = [
  { label: "BEGINNER", value: "BEGINNER" },
  { label: "ADDRESS_KYC", value: "ADDRESS_KYC" },
  { label: "NIN_KYC", value: "NIN_KYC" },
  { label: "BVN_KYC", value: "BVN_KYC" },
  { label: "CAC_KYC", value: "CAC_KYC" },
];

const RejectKycModal: React.FC<RejectKycModalProps> = ({
  isOpen,
  onClose,
  user,
  onSave,
}) => {
  const [kycStatus, setKycStatus] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [errors, setErrors] = useState<{ kycStatus?: string }>({});

  const validateForm = async () => {
    try {
      await validationSchema.validate({ kycStatus }, { abortEarly: false });
      setErrors({});
      return true;
    } catch (validationErrors: any) {
      const validationResult: { [key: string]: string } = {};
      validationErrors.inner.forEach((err: any) => {
        validationResult[err.path] = err.message;
      });
      setErrors(validationResult);
      return false;
    }
  };

  const handleSave = async () => {
    const isValid = await validateForm();
    if (isValid) {
      setConfirmOpen(true);
    }
  };

  const handleDiscard = () => {
    setKycStatus("");
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <CustomModalContainer
      title="Update KYC Status"
      footer={
        <div className="flex justify-between">
          <Button
            type="button"
            onClick={handleDiscard}
            label="Discard"
            customStyle={{
              width: "auto",
              minWidth: "150px",
              background: "none",
              color: "#000",
            }}
          />
          <Button
            type="button"
            onClick={handleSave}
            label="Save Changes"
            customStyle={{
              width: "auto",
              minWidth: "150px",
            }}
          />
        </div>
      }
      open={isOpen}
      onClose={handleDiscard}
    >
      <div className="p-6">
        <form>
          <Dropdown
            label="KYC Status"
            options={kycStatusOptions}
            value={kycStatus}
            onSelect={(value) => setKycStatus(value)}
            placeholder="Select KYC status"
            required
            error={errors.kycStatus}
          />
        </form>
      </div>

      <ConfirmRejectKycModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        userId={user?.user?.id}
        kycStatus={kycStatus}
        onRejected={() => {
          setConfirmOpen(false);
          onSave();
        }}
      />
    </CustomModalContainer>
  );
};

export default RejectKycModal;
